import { BlockingModalType } from 'v2/types'
import { phoneSDK } from 'v2/utils/phone-sdk'

export interface BlockingModalConfig {
  title: string
  description: string
  primaryAction: string
  secondaryAction: string
  showDoNotShowAgain?: boolean
  onPrimaryAction: () => void
  onSecondaryAction?: () => void
}

export const modalConfigs: Record<BlockingModalType, BlockingModalConfig> = {
  [BlockingModalType.ACTIVE_CALL_LOGOUT]: {
    title: 'Active Call in Progress',
    description:
      'You have an active call. Are you sure you want to logout? This will end the call.',
    primaryAction: 'End Call & Logout',
    secondaryAction: 'Cancel',
    onPrimaryAction: () => {
      phoneSDK.destroy()
      setTimeout(() => {
        window.cx.logout()
      }, 1000)
    },
  },
}
